module.exports = __webpack_public_path__ + "img/Speaker=Neil Sharma.cb7379ee.png";